import axios from 'axios';
import { API_ROOT, logApiError } from '@/store/api';

export default {
    namespaced: true,
    state: {
        articles: {},
        // slug -> hero_image_url for published articles that have one. Null until loaded.
        heroImages: null,
    },
    getters: {
        // Always an object so consumers can index it without a null guard.
        heroImages: state => state.heroImages || {},
    },
    mutations: {
        setArticle(state, { slug, article }) {
            state.articles[slug] = article;
        },
        setHeroImages(state, map) {
            state.heroImages = map;
        },
    },
    actions: {
        async getArticle({ dispatch, state, commit }, slug) {
            if (!state.articles[slug]) {
                try {
                    const res = await axios.get(`${API_ROOT}/articles/${slug}/`);

                    commit('setArticle', { slug, article: res['data'] });
                } catch (e) {
                    logApiError(e, dispatch);
                    return null;
                }
            }

            return state.articles[slug] ?? null;
        },
        // Slim slug -> hero image map used to give strategy/article cards their visual.
        // Fetched once and cached; articles without a hero image are omitted so callers
        // can fall back to a placeholder.
        async getHeroImages({ dispatch, state, commit }) {
            if (state.heroImages) return state.heroImages;

            try {
                const res = await axios.get(`${API_ROOT}/articles/`);
                const map = {};
                (res['data'] ?? []).forEach(article => {
                    if (article.hero_image_url) {
                        map[article.slug] = article.hero_image_url;
                    }
                });
                commit('setHeroImages', map);
            } catch (e) {
                logApiError(e, dispatch);
                commit('setHeroImages', {});
            }

            return state.heroImages;
        },
    },
};
